import React, { useEffect, useState } from "react";
import { Button, Col, Figure, Form, Modal, Row } from "react-bootstrap";
import {
  addAndUpdateTeam,
  addAndUpdateUser,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { MaxLength } from "../../../utils/constants/CharactersLength";
import { ValidationMessage } from "../../../utils/constants/validationMessage";
import { whiteSpaceCheck } from "../../../helper/helper";
import { Loader } from "lucide-react";
import { BASE_URL } from "../../../services/path";
import CropImageModal from "../../../components/shared/modal/CropImageModal";

const AddEdit = ({
  show,
  onHide,
  modalType,
  currentActiveData,
  fetchedGetUsers,
  setCurrentActiveData,
}) => {
  const notification = useToastContext();

  // HOOK FORM
  const {
    register,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // ALL STATE
  const [profilePic, setProfilePic] = useState("");
  const [profileFile, setProfileFile] = useState("");
  const [loading, setLoading] = useState(false);
  // ALL STATE
  const [showCropModal, setShowCropModal] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);

  const onSubmit = (data) => {
    const formData = new FormData();
    // if (data?.profileImage?.[0]) {
    //   formData.append("volentierPic", data?.profileImage?.[0]);
    // }
    if (profileFile) {
      formData.append("volentierPic", profileFile);
    }
    formData.append("name", data?.name || "");
    formData.append("position", data?.position || "");

    const userData = { modalTypes: modalType, id: currentActiveData?._id };

    addAndUpdateTeam(formData, userData, notification, (loading, error) => {
      setLoading(loading);
      if (!error) {
        fetchedGetUsers();
        onHide();
      }
    });
  };
  useEffect(() => {
    if (modalType == "edit") {
      setValue("name", currentActiveData?.name || "");
      setValue("position", currentActiveData?.position || "");
      const imageUrl =
        BASE_URL + "/uploads/" + currentActiveData?.volentierPic || "";
      setProfilePic(imageUrl);
    }
  }, [modalType]);

  useEffect(() => {
    const profileData = watch("profileImage")?.[0];
    const imageUrl =
      BASE_URL + "/uploads/" + currentActiveData?.volentierPic || "";
    setProfileFile(watch("profileImage") || []);
    setProfilePic(
      typeof profileData === "object"
        ? URL.createObjectURL(profileData)
        : modalType == "edit"
        ? imageUrl
        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzJtv72esjEWvfSpkux9LhOEGiBQ5vuR8drQ&s"
    );
  }, [watch("profileImage")]);

  const handleProfileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ["image/png", "image/jpg", "image/jpeg"];
      if (!allowedTypes.includes(file.type)) {
        notification.error("Please upload an image in PNG,JPEG or JPG format.");
        return;
      }

      if (file.size > 300 * 1024) {
        notification.error("Please upload an image smaller than 300 KB.");
        return;
      }
      const blobURL = URL.createObjectURL(file);
      setImageToCrop(blobURL);
      setShowCropModal(true);
      setProfileFile(file);
    }
  };

  const saveCroppedImage = (croppedAreaPixels) => {
    if (!croppedAreaPixels || !imageToCrop) return;

    const image = new Image();
    image.src = imageToCrop;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      // Generate a dynamic filename with timestamp
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      var dynamicFileName = `cropped-image-${timestamp}.png`;
      dynamicFileName.replace("-", "_");

      canvas.toBlob((blob) => {
        const croppedFile = new File([blob], dynamicFileName, {
          type: "image/png",
        });
        setProfilePic(URL.createObjectURL(croppedFile)); // Update the profile picture
        setProfileFile(croppedFile); // Save the cropped file
      }, "image/png");
    };
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setCurrentActiveData({});
        onHide();
      }}
      centered
    >
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="fw-bold fs-5">Add Team</Modal.Title>
      </Modal.Header>
      <Form
        className="common-modal"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        autoComplete="off"
      >
        <Modal.Body className="p-4">
          <Row>
            {/* <Col md={12} className="mb-4">
              <div className="profile-container">
                <Figure className="profile-figure">
                  <Figure.Image
                    src={profilePic}
                    alt="No_Image"
                    className="profile-image"
                  />
                  <span className="camera-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="camera-svg"
                    >
                      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                      <circle cx="12" cy="13" r="3"></circle>
                    </svg>
                  </span>
                  <input
                    type="file"
                    accept="image/*"
                    className="profile-file-input"
                    // onChange={handleProfileUpload}
                    name="profileImage"
                    {...register("profileImage", {
                      validate: (fileList) => {
                        const file = fileList[0];
                        const allowedTypes = [
                          "image/jpeg",
                          "image/png",
                          "image/jpg",
                        ];
                        if (file || modalType !== "edit") {
                          if (!file) return "Member image is required.";
                          if (!allowedTypes.includes(file.type)) {
                            return "Only JPEG, JPG, and PNG files are allowed.";
                          }
                        }
                        return true;
                      },
                    })}
                  />
                </Figure>
              </div>
              <div className="d-flex justify-content-center align-item-center">
                <ErrorMessage
                  errors={errors}
                  name="profileImage"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </div>
            </Col> */}

            <Col md={12} className="mb-md-4 mb-2">
              <div className="profile-container">
                <Figure className="profile-figure">
                  <Figure.Image
                    src={profilePic}
                    alt="Profile"
                    className="profile-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
                    }}
                  />
                  <span className="camera-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="camera-svg"
                    >
                      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                      <circle cx="12" cy="13" r="3"></circle>
                    </svg>
                  </span>
                  <input
                    type="file"
                    accept="image/*"
                    className="profile-file-input"
                    onChange={handleProfileUpload}
                  />
                </Figure>
              </div>

              {/* Crop Image Modal */}
              {showCropModal && (
                <CropImageModal
                  show={showCropModal}
                  handleClose={() => setShowCropModal(false)}
                  imageSrc={imageToCrop}
                  saveCroppedImage={saveCroppedImage}
                />
              )}
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  name="name"
                  {...register("name", {
                    required: ValidationMessage.NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  // maxLength={MaxLength.nameLen}
                />
                <ErrorMessage
                  errors={errors}
                  name="name"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Position</Form.Label>
                <Form.Select
                  name="position"
                  {...register("position", {
                    required: ValidationMessage?.POSITION_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                >
                  <option value="">Select gender</option>
                  <option value="Guard">Guard (सरक्षक)</option>
                  <option value="ChiefSecretary">
                    Chief Secretary (अध्र्क्ष)
                  </option>
                  <option value="GeneralTreasury">
                    General Treasury (महासजचव ){" "}
                  </option>

                  <option value="Chief">Chief (कोषाध्र्क्ष) </option>
                  <option value="Co-Treasurer">
                    Co-Treasurer (सह कोषाध्यक्ष)
                  </option>
                  <option value="VicePresident">
                    Vice President (उपाध्यक्ष)
                  </option>
                  <option value="JointSecretary">
                    Joint Secretary (संयुक्त सचिव)
                  </option>
                  <option value="OrganizationSecretary">
                    Organization Secretary (संगठन सचिव)
                  </option>
                  <option value="WomenCellInCharge">
                    Women Cell In Charge (महिला प्रकोष्ठ प्रभारी)
                  </option>
                  <option value="YouthCellInCharge">
                    Youth Cell In Charge (युवा प्रकोष्ठ प्रभारी)
                  </option>
                  <option value="CulturalInCharge">
                    Cultural In Charge (सांस्कृतिक प्रभारी)
                  </option>
                  <option value="MediaInCharge">
                    Media In Charge (मीडिया प्रभारी)
                  </option>
                  <option value="Volunteer">
                    Volunteer (कार्यकारणी सदस्य){" "}
                  </option>
                </Form.Select>

                <ErrorMessage
                  errors={errors}
                  name="position"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            type="submit"
            className="bg-orange border-0"
            disabled={loading}
            style={loading ? { cursor: "not-allowed" } : { cursor: "pointer" }}
          >
            Submit{" "}
            {loading && (
              <Loader
                style={{
                  marginLeft: "20px",
                }}
                className="loader"
              />
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEdit;
